import { render, staticRenderFns } from "./createBulkPromotion.vue?vue&type=template&id=79e9c04b&scoped=true&"
import script from "./createBulkPromotion.vue?vue&type=script&lang=js&"
export * from "./createBulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./createBulkPromotion.vue?vue&type=style&index=0&id=79e9c04b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9c04b",
  null
  
)

export default component.exports